module.exports = {
  email: 'jeancalvin027@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/cal250',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/calvin_sta_',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/jean_calvin',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/rwaburindi-jean-calvin-4921ab296/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#a6a6a6',
    navy: '#0a192f',
    darkNavy: '#111822',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
